const PrivateRouteConst = {
  FREQUENCY_VIEW: 'allFrequencyView',
  FREQUENCY_EDIT: 'allFrequencyEdit',
  FREQUENCY_DELETE: 'allFrequencyDelete',
  SELF_FREQUENCY_VIEW: 'selfFrequencyView',
  SELF_FREQUENCY_EDIT: 'selfFrequencyEdit',
  SELF_FREQUENCY_DELETE: 'selfFrequencyDelete',
  CREATE_FREQUENCY: 'createFrequency',

  WORKFLOW_VIEW: 'allWorkflowView',
  WORKFLOW_EDIT: 'allWorkflowEdit',
  WORKFLOW_DELETE: 'allWorkflowDelete',
  SELF_WORKFLOW_VIEW: 'selfWorkflowView',
  SELF_WORKFLOW_EDIT: 'selfWorkflowEdit',
  SELF_WORKFLOW_DELETE: 'selfWorkflowDelete',
  CREATE_WORKFLOW: 'createWorkflow',
  CREATE_CONFIG_WORKFLOW: 'createConfigWorkflow',

  RULES_VIEW: 'allRulesView',
  RULES_EDIT: 'allRulesEdit',
  RULES_DELETE: 'allRulesDelete',
  SELF_RULES_VIEW: 'selfRulesView',
  SELF_RULES_EDIT: 'selfRulesEdit',
  SELF_RULES_DELETE: 'selfRulesDelete',
  CREATE_RULE: 'createRule',

  GRID_VIEW: 'gridView',
  GRID_EDIT: 'gridEdit',
  GRID_ADD_COLUMN: 'gridAddColumn',
  GRID_ADD_ROW: 'gridAddRow',
  SHOW_GRID_FILTER: 'showGridFilter',
  RULE_APPLICABILITY_VIEW: 'ruleApplicabilityView',
  RULE_APPLICABILITY_EDIT: 'ruleApplicabilityEdit',
  OUTPUT_FORMULA_VIEW: 'outputFormulaView',
  OUTPUT_FORMULA_EDIT: 'outputFormulaEdit',
  CUSTOM_RULE_CREATE: 'customRuleCreate',
  COMMAN_RULE_CREATE: 'commanRuleCreate',

  RULE_GROUPS_VIEW: 'allRuleGroupsView',
  RULE_GROUPS_EDIT: 'allRuleGroupsEdit',
  RULE_GROUPS_DELETE: 'allRuleGroupsDelete',
  SELF_RULE_GROUPS_VIEW: 'selfRuleGroupsView',
  SELF_RULE_GROUPS_EDIT: 'selfRuleGroupsEdit',
  SELF_RULE_GROUPS_DELETE: 'selfRuleGroupsDelete',
  CREATE_RULE_GROUPS: 'createRuleGroups',

  RULE_PLANS_VIEW: 'allRulePlansView',
  RULE_PLANS_EDIT: 'allRulePlansEdit',
  RULE_PLANS_DELETE: 'allRulePlansDelete',
  SELF_RULE_PLANS_VIEW: 'selfRulePlansView',
  SELF_RULE_PLANS_EDIT: 'selfRulePlansEdit',
  SELF_RULE_PLANS_DELETE: 'selfRulePlansDelete',
  CREATE_RULE_PLANS: 'createRulePlans',

  CONFIG_PROGRAM_VIEW: 'allConfigProgramView',
  CONFIG_PROGRAM_EDIT: 'allConfigProgramEdit',
  CONFIG_PROGRAM_DELETE: 'allConfigProgramDelete',
  SELF_CONFIG_PROGRAM_VIEW: 'selfConfigProgramView',
  SELF_CONFIG_PROGRAM_EDIT: 'selfConfigProgramEdit',
  SELF_CONFIG_PROGRAM_DELETE: 'selfConfigProgramDelete',
  CREATE_CONFIG_PROGRAM: 'createConfigProgram',

  TARGET_SETTING_CONFIG_VIEW: 'allTargetSettingConfigView',
  TARGET_SETTING_CONFIG_LIST: 'targetSettingConfigList',
  TARGET_HIERARCHY_VIEW: 'targetHierarchyView',

  SHOW_BUTTON: 'programConfigManagementallShowButtons',
  SHOW_FORMULA: 'programConfigManagementallShowFormula',
  EDIT_FORMULA: 'programConfigManagementallEditFormula',

  HOLIDAY_VIEW: 'holidayView',

  CATEGORY_VIEW: 'categoryView',
  CATEGORY_EDIT: 'categoryEdit',
  CATEGORY_DELETE: 'categoryDelete',
  SELF_CATEGORY_VIEW: 'selfCategoryView',
  SELF_CATEGORY_EDIT: 'selfCategoryEdit',
  SELF_CATEGORY_DELETE: 'selfCategoryDelete',
  CREATE_CATEGORY: 'createCategory',

  UPLOAD_PRODUCT_IMAGE_VIEW: 'uploadProductImageView',
  UPLOAD_PRODUCT_IMAGE_EDIT: 'uploadProductImageEdit',
  UPLOAD_PRODUCT_IMAGE_DELETE: 'uploadProductImageDelete',
  SELF_UPLOAD_PRODUCT_IMAGE_VIEW: 'selfUploadProductImageView',
  SELF_UPLOAD_PRODUCT_IMAGE_EDIT: 'selfUploadProductImageEdit',
  SELF_UPLOAD_PRODUCT_IMAGE_DELETE: 'selfUploadProductImageDelete',
  CREATE_UPLOAD_PRODUCT_IMAGE: 'createUploadProductImage',

  CONTEST_VIEW: 'contestView',
  CONTEST_EDIT: 'contestEdit',
  CONTEST_DELETE: 'contestDelete',
  SELF_CONTEST_VIEW: 'selfContestView',
  SELF_CONTEST_EDIT: 'selfContestEdit',
  SELF_CONTEST_DELETE: 'selfContestDelete',
  CREATE_CONTEST: 'createContest',

  ALL_GRID_APPROVAL_WORKFLOW_VIEW: 'allGridApprovalWorkflowView',
  ALL_GRID_APPROVAL_WORKFLOW_EDIT: 'allGridApprovalWorkflowEdit',
  ALL_GRID_APPROVAL_WORKFLOW_DELETE: 'allGridApprovalWorkflowDelete',
  SELF_GRID_APPROVAL_WORKFLOW_VIEW: 'selfGridApprovalWorkflowView',
  CREATE_GRID_APPROVAL_WORKFLOW: 'createGridApprovalWorkflow',
  SELF_GRID_APPROVAL_WORKFLOW_EDIT: 'selfGridApprovalWorkflowEdit',
  SELF_GRID_APPROVAL_WORKFLOW_DELETE: 'selfGridApprovalWorkflowDelete',

  RULE_BULK_UPLOAD: 'ruleBulkUpload',
  RULE_BULK_DOWNLOAD: 'ruleBulkDownload',
  QUERY_VIEW: 'allQueryView',
  QUERY_EDIT: 'allQueryEdit',
  QUERY_DELETE: 'allQueryDelete',
  SELF_QUERY_VIEW: 'selfQueryView',
  SELF_QUERY_EDIT: 'selfQueryEdit',
  SELF_QUERY_DELETE: 'selfQueryDelete',
  CREATE_QUERY: 'createQuery',
};
export default PrivateRouteConst;
